import React, { useEffect } from 'react'
import {
    Box,
    Button,
    Grid,
} from '@material-ui/core'
import { attributeGroups } from '../../../../store/slices'
import { useAppDispatch, useAppSelector } from '../../../../store'
import { useHistory } from 'react-router-dom'
import { unwrapResult } from '@reduxjs/toolkit'
import { SideBar } from '../../../../components/side-bar'
import { Content } from '../../../../components/content'
import { validation } from '../../../../services'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import { navLinksProduct } from '../../../../services/product'

interface AttributeGroupEditPageProps {
    match: {
        params: {
            id: string
        }
    }
}

export function AttributeGroupEditPage(props: AttributeGroupEditPageProps): JSX.Element {
    useEffect(() => {
        dispatch(attributeGroups.actions.fetch())
    }, [])

    const dispatch = useAppDispatch()
    const history = useHistory()

    const attributeGroup = useAppSelector((state) => attributeGroups.selectors.selectById(state, props.match.params.id))

    const initialValues = {
        id: attributeGroup?.iri || '',
        name: attributeGroup?.name || '',
    }

    return (
        <Formik
            initialValues={initialValues}
            enableReinitialize
            onSubmit={(values, { setSubmitting }) => {
                dispatch(attributeGroups.actions.update({iri: values.id, data: values}))
                    .then(unwrapResult)
                    .then(() => {
                        history.goBack()
                    })
                setSubmitting(false)
            }}
        >
            {({ submitForm }) => (
                <Form>
                    <Box display="flex">
                        <SideBar navLinks={navLinksProduct}>
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={submitForm}
                            >
                                Сохранить
                            </Button>
                        </SideBar>
                        <Content loading={false} notFoundContent={false} title={'Редактирование группы атрибутов'}>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <Field
                                        component={TextField}
                                        label="Название"
                                        name="name"
                                        fullWidth
                                        validate={validation.required}
                                    />
                                </Grid>
                            </Grid>
                        </Content>
                    </Box>
                </Form>
            )}
        </Formik>
    )
}